import { Field, FieldProps } from '@reckon-web/field';
import { DatePicker, DatePickerProps } from '@reckon-web/date-picker';

export type { ISODate } from '@reckon-web/date-picker';

type DatePickerFieldProps = DatePickerProps & FieldProps;

export const DatePickerField = ({
  description,
  helpText,
  id,
  invalidMessage,
  label,
  labelVisible,
  reserveMessageSpace,
  ...inputProps
}: DatePickerFieldProps) => {
  return (
    <Field
      description={description}
      helpText={helpText}
      id={id}
      invalidMessage={invalidMessage}
      label={label}
      labelVisible={labelVisible}
      reserveMessageSpace={reserveMessageSpace}
    >
      <DatePicker {...inputProps} />
    </Field>
  );
};
